export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakaznikKat';
export const NAME = 'ZakaznickaKategorie';
